"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;

var _react = _interopRequireDefault(require("react"));

var _Theme = require("../../../Theme");

var _v = require("./v2");

var _v2 = require("./v3");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * `Card` is a card with one image one tall image, and text for title and subtitle
 * at the bottom.
 */


var Card = function Card(props) {
  var Component = (0, _Theme.useThemeConfig)({
    v2: _v.Card,
    v3: _v2.Card
  });
  return /*#__PURE__*/_react.default.createElement(Component, props);
};

exports.Card = Card;
Card.displayName = "Card";